{
  "failedPaymentsMsgForAdmins": "Pay the outstanding account balance to avoid service interruption. <a href='{{ url }}'>Make a payment</a>",
  "failedPaymentsMsgForMembers": "There is an outstanding balance due. Contact your account admin to avoid service interruption.",
  "failedPaymentsMsgContract": "Your account has an overdue balance. Pay now to avoid service interruption or contact your CSM for assistance."
}
